import { tva as gluestackTva } from '@gluestack-ui/utils/nativewind-utils'
import { extendTailwindMerge } from 'tailwind-merge'

import { TV_MERGE_CONFIG, TW_MERGE_CONFIG } from './mergeConfig'

/**
 * `twMerge` that keeps a named font size when a text colour sits beside it.
 *
 * The default instance reads `text-body-md` as a colour, so `twMerge('text-body-md',
 * 'text-content-default')` returns only the colour and the size is gone. Nothing
 * fails: both classes are real, the element just renders at the inherited size. That
 * is how a typography pass once shipped every form label in black on near-black.
 *
 * Import this instead of `tailwind-merge` anywhere a size and a colour can meet.
 */
export const twMerge = extendTailwindMerge(TW_MERGE_CONFIG)

/**
 * `tva` with the same separation applied.
 *
 * gluestack's `tva` forwards its second argument to `tailwind-variants`, which resolves
 * tailwind-merge separately from the repo and may answer to either config shape — see
 * `mergeConfig.ts`.
 *
 * `twMergeConfig` is set last on purpose: a caller passing one of their own would
 * otherwise replace the whole object and silently lose the size/colour separation,
 * which fails by rendering rather than by throwing. Everything else a caller passes
 * is kept. A call site that genuinely needs different merge rules should extend
 * `TV_MERGE_CONFIG` in `mergeConfig.ts`, where the spec covers it.
 */
export const tva: typeof gluestackTva = (options, config) =>
    gluestackTva(options, { ...config, twMergeConfig: TV_MERGE_CONFIG } as never)
